import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import updateaction from "../../context/action/mizania/updateaction";
import deleteaction from "../../context/action/mizania/deleteaction";

const Editmizaniamodal = (props) => {
    const { initState, recaller, setrecaller, clear, initDispatch } =
        useContext(GlobalContext);
    
    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState(false);
    const [error2, seterror2] = useState(false);
    return (
        <div>
              <>
                {props.show ? (
                  <>
                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                      <div className="relative my-6 mx-auto w-11/12 sm:w-5/6 md:w-2/3 lg:w-1/2 max-w-2xl">
                        {/*content*/}
                        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                          {/*header*/}
                          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                            <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                              گۆڕانکاری
                            </h3>
                            <button
                              className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                              onClick={() => props.setshow(false)}
                            >
                              <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                                X
                              </span>
                            </button>
                          </div>
                          {/*body*/}
                          <div className="relative p-4 sm:p-6 flex-auto">
                            <div className="grid grid-cols-1 gap-4 w-full">
                              <div className="w-full">
                                <label
                                  className={
                                    "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                  }
                                  htmlFor="mizania_statement_number"
                                >
                                  رقم الكشف
                                </label>
                                <input
                                  className={
                                    "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                  }
                                  id="mizania_statement_number"
                                  type="text"
                                  placeholder=""
                                  onClick={(val)=>{val.target.select()}}
                                  value={props.mizania_statement_number}
                                  onChange={(val) =>
                                    props.setmizania_statement_number(val.target.value)
                                  }
                                />
                              </div>
                              <div className="w-full">
                                <label
                                  className={
                                    "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                  }
                                  htmlFor="mizania_directory_number"
                                >
                                  رقم الدليل
                                </label>
                                <input
                                  className={
                                    "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                  }
                                  id="mizania_directory_number"
                                  type="text"
                                  placeholder=""
                                  onClick={(val)=>{val.target.select()}}
                                  value={props.mizania_directory_number}
                                  onChange={(val) =>
                                    props.setmizania_directory_number(val.target.value)
                                  }
                                />
                              </div>
                              <div className="w-full">
                                <label
                                  className={
                                    error
                                      ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                                      : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                  }
                                  htmlFor="mizania_name"
                                >
                                  ناو
                                </label>
                                <input
                                  className={
                                    error
                                      ? "appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12 cursor-not-allowed"
                                      : "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12 cursor-not-allowed"
                                  }
                                  disabled
                                  id="mizania_name"
                                  type="text"
                                  placeholder=""
                                  onClick={(val)=>{val.target.select()}}
                                  value={props.mizania_name}
                                  onChange={(val) =>
                                    props.setmizania_name(val.target.value)
                                  }
                                  onFocus={() => seterror(false)}
                                />
                              </div>
                              <div className="w-full">
                                <label
                                  className={
                                    error1
                                      ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                                      : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                  }
                                  htmlFor="mizania_amount"
                                >
                                  بڕ
                                </label>
                                <input
                                  className={
                                    error1
                                      ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                      : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                  }
                                  id="mizania_amount"
                                  type="text"
                                  placeholder=""
                                  onClick={(val)=>{val.target.select()}}
                                  value={props.mizania_amount}
                                  onChange={(val) =>
                                    props.setmizania_amount(val.target.value)
                                  }
                                  onFocus={() => seterror1(false)}
                                />
                              </div>
                              <div className="w-full">
                                <label
                                  className={
                                    error2
                                      ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                                      : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                  }
                                  htmlFor="mizania_date"
                                >
                                  ساڵ
                                </label>
                                <select
                                    className={
                                    error2
                                        ? "w-full h-10 px-3 border border-red-500 rounded text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-gray-200 cursor-not-allowed"
                                        : "w-full h-10 px-3 border border-slate-200 rounded text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-200 cursor-not-allowed"
                                    }
                                    disabled
                                    id="mizania_date"
                                    value={props.mizania_date}
                                    onChange={(val) => props.setmizania_date(val.target.value)}
                                    onFocus={() => seterror2(false)}
                                >
                                    {Array.from({ length: 15 }, (_, i) => new Date().getFullYear() - i).map((y) => (
                                    <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                              </div>
                              <div className="w-full">
                                <label
                                  className={
                                    "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                  }
                                  htmlFor="mizania_category"
                                >
                                  جۆر
                                </label>
                                <select
                                    className={
                                      "w-full h-10 px-3 border border-slate-200 rounded text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-50"
                                    }
                                    id="mizania_category"
                                    value={props.mizania_category}
                                    onChange={(val) => props.setmizania_category(val.target.value)}
                                >
                                    <option value="الموجودات">الموجودات</option>
                                    <option value="الموجودات الثابتة">الموجودات الثابتة</option>
                                    <option value="الموجودات المتداولة">الموجودات المتداولة</option>
                                    <option value="مصادر التمويل">مصادر التمويل</option>
                                    <option value="المطلوبات المتداولة">المطلوبات المتداولة</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          {/*footer*/}
                          <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                            <button
                              className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                              type="button"
                              onClick={() => {
                                if (
                                  window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") ==
                                  true
                                ) {
                                    deleteaction(props.mizania_id)(recaller)(setrecaller)(initDispatch)(clear);
                                }
                              }}
                            >
                              ڕەشکردنەوە
                            </button>
                            <button
                              className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2"
                              type="button"
                              onClick={() => {
                                if (props.mizania_name.trim() == "" || !props.mizania_name) {
                                  seterror(true);
                                  return false;
                                }
                                if (props.mizania_amount < 0) {
                                  seterror1(true);
                                  return false;
                                }
                                if (props.mizania_date.trim() == "" || !props.mizania_date) {
                                  seterror1(true);
                                  return false;
                                }
                                if (
                                  window.confirm(
                                    "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                                  ) == true
                                ) {
                                    updateaction(
                                        props.mizania_id,
                                        props.mizania_statement_number,
                                        props.mizania_directory_number,
                                        props.mizania_name,
                                        props.mizania_amount,
                                        props.mizania_date,
                                        props.mizania_category
                                    )(recaller)(setrecaller)(initDispatch)(clear);
                                }
                              }}
                            >
                              گۆڕانکاری
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                  </>
                ) : null}
              </>
        </div>
    )
}

export default Editmizaniamodal